import React, { useState } from "react";
import { Col, Form, Row, Button } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router";
import { addFourniture } from "../JS/actions/fournitures";

const AddFourr = () => {
  const [founiture, setFourniture] = useState({});
  const dispatch = useDispatch();
  const history = useHistory();

  const handleChange = (e) => {
    setFourniture({ ...founiture, [e.target.name]: e.target.value });
  };
  const handleSave = (e) => {
    e.preventDefault();
    // if (edit) {
    //   dispatch(editEvent(params.id, event, history));
    //   alert("event updated succesfully :)");
    // } else {
    dispatch(addFourniture(founiture, history));
    alert("founiture added succesfully :)");
  };
  return (
    <div>
      <Form className="addFamily">
        <h1 style={{ textAlign: "center", color: "black" }}>
          {" "}
          Ajouter une Founiture{" "}
        </h1>

        <Row className="mb-3">
          <Form.Group as={Col}>
            <Form.Label>Nom fourniture</Form.Label>
            <Form.Control
              onChange={handleChange}
              type="text"
              placeholder="Entrez le nom"
              name="title"
              required
            />
          </Form.Group>

          <Form.Group as={Col}>
            <Form.Label> Desription</Form.Label>
            <Form.Control
              onChange={handleChange}
              type="text"
              placeholder="Description"
              name="description"
              required
            />
          </Form.Group>
        </Row>
        <Form.Group as={Col}>
          <Form.Label>Qte</Form.Label>
          <Form.Control
            onChange={handleChange}
            type="number"
            placeholder="qte"
            name="qte"
            required
          />
        </Form.Group>
        {/* <Form.Group as={Col} controlId="formGridState">
          <Form.Label>Type event</Form.Label>
          <Form.Select
            onChange={handleChange}
            placeholder="Type event"
            name="eventType"
            type="text"
            defaultValue="Choose..."
            required
          >
            <option>Choisir...</option>
            <option>evennement</option>
            <option>action</option>
          </Form.Select>
        </Form.Group> */}

        <Row className="mb-3"></Row>

        <Button
          onClick={handleSave}
          style={{ marginBottom: "15px" }}
          variant="primary"
          type="submit"
        >
          Submit
        </Button>
      </Form>
    </div>
  );
};

export default AddFourr;
